/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Tile_Email_DescInputs */

const tr_landing_community_tile_email_desc = /** @type {(inputs: Landing_Community_Tile_Email_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detaylı sorunlar için. Mesai saatlerinde yanıtlarız.`)
};

const en_landing_community_tile_email_desc = /** @type {(inputs: Landing_Community_Tile_Email_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For detailed issues. We reply during business hours.`)
};

const de_landing_community_tile_email_desc = /** @type {(inputs: Landing_Community_Tile_Email_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für ausführliche Anliegen. Wir antworten während der Geschäftszeiten.`)
};

const ru_landing_community_tile_email_desc = /** @type {(inputs: Landing_Community_Tile_Email_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для сложных вопросов. Отвечаем в рабочее время.`)
};

/**
* | output |
* | --- |
* | "For detailed issues. We reply during business hours." |
*
* @param {Landing_Community_Tile_Email_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_tile_email_desc = /** @type {((inputs?: Landing_Community_Tile_Email_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Tile_Email_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_tile_email_desc(inputs)
	if (locale === "de") return de_landing_community_tile_email_desc(inputs)
	if (locale === "ru") return ru_landing_community_tile_email_desc(inputs)
	return tr_landing_community_tile_email_desc(inputs)
});